import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_THONGKETHU } from "actions/ThongKeThu/actionTypes";
import {
  getListThongKeThuSuccess,
  getListThongKeThuFailure,
} from "actions/ThongKeThu";
import ThongKeThuApi from "service/thongKeThuApi";
import { pushNotification } from "utils/notifications";

function* getListThongKeThu(action) {
  try {
    const response = yield call(ThongKeThuApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListThongKeThuSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListThongKeThuFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListThongKeThuFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_THONGKETHU, getListThongKeThu);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
